export default __webpack_public_path__ + "static/media/story_otomo-4.33efd7cb.png";